import styled from 'styled-components';

export const Wrapper = styled.div`
padding-top: 3rem;
margin-bottom: 3rem;
width: 100%;
max-width: 1640px;
`

export const MakersMarket = () => {

  return (
    <Wrapper>

      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>Makers Market</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <p style={{marginTop: '2rem', fontSize: '1.2rem'}}>Vendors will be announced soon — stay tuned!</p>
      </div>
    </Wrapper>
  )
}
